module.exports = __webpack_public_path__ + "media/images/responsive/page_common/noimage/square/text_gray02-0f230bfe4ca74aa6dda6cd373fc815df.png";